export const lightGray = "#E6E7E8";
export const red = "#ff0000";
export const black = "#000000";
export const darkGray = "#5b5b5b";
export const almostBlack = "#474747";
export const opaqueLightGray = "#f3f3f3b0";
export const translucentWhite = "#ffffffbb";
export const translucentWhite2 = "#ffffffdd";
